import React from "react";

function GearLogo() {
  const gearPath = (cx, cy, outerR, innerR, teeth) => {
    const points = [];
    const toothAngle = (2 * Math.PI) / teeth;
    const halfTooth = toothAngle / 4;

    for (let i = 0; i < teeth; i++) {
      const angle = i * toothAngle - Math.PI / 2;
      points.push([
        cx + innerR * Math.cos(angle - halfTooth),
        cy + innerR * Math.sin(angle - halfTooth),
      ]);
      points.push([
        cx + outerR * Math.cos(angle - halfTooth * 0.5),
        cy + outerR * Math.sin(angle - halfTooth * 0.5),
      ]);
      points.push([
        cx + outerR * Math.cos(angle + halfTooth * 0.5),
        cy + outerR * Math.sin(angle + halfTooth * 0.5),
      ]);
      points.push([
        cx + innerR * Math.cos(angle + halfTooth),
        cy + innerR * Math.sin(angle + halfTooth),
      ]);
    }

    return (
      "M " +
      points.map((p) => `${p[0].toFixed(2)},${p[1].toFixed(2)}`).join(" L ") +
      " Z"
    );
  };

  const teeth = 10;
  const outerR = 18;
  const innerR = 14;
  const pitchR = (outerR + innerR) / 2;
  const gap = pitchR * 2 + 1.5;

  const g1x = 22;
  const g1y = 22;
  const g2x = g1x + gap;
  const g2y = g1y;

  const offsetAngle = 360 / teeth / 2;

  return (
    <svg
      width="76"
      height="44"
      viewBox="0 0 76 44"
      xmlns="http://www.w3.org/2000/svg"
      className="gear-logo"
    >
      <defs>
        <linearGradient id="gearGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#c770f0" />
          <stop offset="100%" stopColor="#9a4dff" />
        </linearGradient>
      </defs>

      <g className="gear-spin-cw" style={{ transformOrigin: `${g1x}px ${g1y}px` }}>
        <path
          d={gearPath(g1x, g1y, outerR, innerR, teeth)}
          fill="none"
          stroke="url(#gearGrad)"
          strokeWidth="1.5"
        />
        <circle
          cx={g1x}
          cy={g1y}
          r={innerR - 3}
          fill="none"
          stroke="url(#gearGrad)"
          strokeWidth="1"
          opacity="0.4"
        />
        <text
          x={g1x}
          y={g1y}
          textAnchor="middle"
          dominantBaseline="central"
          fill="#c770f0"
          fontSize="13"
          fontWeight="800"
          fontFamily="'Poppins', sans-serif"
        >
          D
        </text>
      </g>

      <g className="gear-spin-ccw" style={{ transformOrigin: `${g2x}px ${g2y}px` }}>
        <path
          d={gearPath(g2x, g2y, outerR, innerR, teeth)}
          fill="none"
          stroke="url(#gearGrad)"
          strokeWidth="1.5"
          transform={`rotate(${offsetAngle}, ${g2x}, ${g2y})`}
        />
        <circle
          cx={g2x}
          cy={g2y}
          r={innerR - 3}
          fill="none"
          stroke="url(#gearGrad)"
          strokeWidth="1"
          opacity="0.4"
        />
        <text
          x={g2x}
          y={g2y}
          textAnchor="middle"
          dominantBaseline="central"
          fill="#c770f0"
          fontSize="13"
          fontWeight="800"
          fontFamily="'Poppins', sans-serif"
        >
          R
        </text>
      </g>
    </svg>
  );
}

export default GearLogo;
